module.exports = __webpack_public_path__ + "static/media/Img-onboarding-tokens-04.5da472a4.png";